import React from "react";
import { XCircleIcon } from "@heroicons/react/solid";
import { Modal } from "../../components";
import { toAbsoluteUrl } from "../../../services";
import { ActionMenuData } from "./data";

const ActionModal = (props) => {
  let handelMenu = (item) => {
    props.handelActionMenu(item.key);
  };

  return (
    <Modal
      classCustom="2xl:w-[15%] xl:w-[15%] lg:w-[20%] md:w-[40%] w-[50%]"
      open={props.actionModal}
      onBackdropClick={props.onBackdropClick}
    >
      <div>
        <div className="bg-[#007E8C] px-2 py-3 flex flow-row items-center justify-between">
          <div className="flex items-center ">
            <img
              src={toAbsoluteUrl("/media/nrp/leaderboard/actionIcon.png")}
              alt="Export"
              style={{
                width: 15,
                height: 15,
                marginRight: 10,
              }}
            />
            <h3 className="text-[#FFFFFF] ml-2 font-semibold ">Action</h3>
          </div>
          <XCircleIcon
            onClick={props.handelNo}
            className="w-7 h-7 cursor-pointer "
            color="white"
          />
        </div>
        <div className="mx-2 py-4 ">
          {ActionMenuData &&
            ActionMenuData.map((item, i) => {
              return (
                <button
                  onClick={() => handelMenu(item)}
                  key={i}
                  className="block hover:bg-[#F2F0F9] px-5 py-1"
                >
                  <p className="text-left text-[18px] text-[#25213B] font-normal ">
                    {item.name}
                  </p>
                </button>
              );
            })}
        </div>
      </div>
    </Modal>
  );
};

export default ActionModal;
